// extracted by mini-css-extract-plugin
module.exports = {"container":"product-reviews_container__kKTme","powerReviewsContainer":"product-reviews_powerReviewsContainer__h2FJQ","title":"product-reviews_title__0jZGa"};